/* eslint-disable enforce-ids-in-jsx/unique-ids */
import React, { useContext } from 'react'
import cls from 'classnames'
import PropTypes from 'prop-types'
import styled, { ThemeContext } from 'styled-components'

import { FillCheck, FillError, FillInfo, FillWarning } from './Icons'

const Notification = ({ id, className, type, text, style, size }) => {
  const theme = useContext(ThemeContext)
  const iconSize = size === 'small' ? '20px' : '24px'

  const MAP_NOTIFICATION_BY_TYPE = {
    info: {
      icon: <FillInfo id={`${id}_icon`} fill={theme.linksColor} width={iconSize} />,
      color: theme.linksColor,
    },
    error: {
      icon: <FillError id={`${id}_icon`} fill={theme.negativeColor} width={iconSize} />,
      color: theme.negativeColor,
    },
    success: {
      icon: <FillCheck id={`${id}_icon`} fill={theme.positiveColor} width={iconSize} />,
      color: theme.positiveColor,
    },
    warning: {
      icon: <FillWarning id={`${id}_icon`} fill={theme.warningColor} width={iconSize} />,
      color: theme.warningColor,
    },
  }

  const textID = `${id}_text`

  return (
    <div
      id={id}
      className={cls(className, 'notification')}
      style={{
        border: `1px solid ${MAP_NOTIFICATION_BY_TYPE[type].color}`,
        borderLeft: `6px solid ${MAP_NOTIFICATION_BY_TYPE[type].color}`,
        ...style,
      }}
    >
      {MAP_NOTIFICATION_BY_TYPE[type].icon}
      <span
        id={textID}
        className={cls(
          'notification__text',
          size === 'small' ? 'typography-subtitle-5' : 'typography-body-1'
        )}
      >
        {text}
      </span>
    </div>
  )
}

const StyledNotification = styled(Notification)`
  padding: ${({ size }) => (size === 'small' ? '0 6px' : '6px 6px 6px 16px')};
  border-radius: ${({ theme }) => theme.borderRadius};
  display: flex;
  align-items: center;

  .notification__text {
    color: ${({ theme }) => theme.ds_gray_1};
    margin-left: 8px;
  }
`
StyledNotification.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  text: PropTypes.string.isRequired,
  style: PropTypes.object,
  size: PropTypes.oneOf(['small', 'large']),
}

StyledNotification.defaultProps = {
  type: 'info',
  size: 'large',
}

export default StyledNotification
